var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",attrs:{"id":"app"}},[_c('router-view'),_c('BackTop',{attrs:{"height":300}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }